import * as React from 'react';
import { useContext } from "react";
import { SelectedPatientContext } from "../SelectedPatientContext.tsx";
import { useNavigate } from "react-router-dom";
import { makeStyles, shorthands, Text, Tab, TabList, Dropdown, Option, useId } from "@fluentui/react-components";
import {
    PersonSettingsFilled, InfoFilled, TimelineRegular, TimelineFilled, PersonNoteRegular,
    PersonAccountsFilled, SettingsRegular, PersonSettingsRegular, InfoRegular,
    BoardSplitRegular, PersonNoteFilled, PersonAccountsRegular, SettingsFilled,
    bundleIcon, BoardSplitFilled, HeartPulseFilled, HeartPulseRegular
} from "@fluentui/react-icons";
import { API_PATH } from '../Constants.ts';

const TherapistsIcon = bundleIcon(PersonAccountsFilled, PersonAccountsRegular);
const SettingsIcon = bundleIcon(SettingsFilled, SettingsRegular);
const BoardSplitIcon = bundleIcon(BoardSplitFilled, BoardSplitRegular);
const AccountIcon = bundleIcon(PersonSettingsFilled, PersonSettingsRegular);
const InfoIcon = bundleIcon(InfoFilled, InfoRegular);
const PatientsIcon = bundleIcon(PersonNoteFilled, PersonNoteRegular);
const TimelineIcon = bundleIcon(TimelineFilled, TimelineRegular);
const HeartPulse = bundleIcon(HeartPulseFilled, HeartPulseRegular);

const tabs = [
    {
        id: "control-panel",
        name: "Control Panel",
        icon: null
    },
    {
        id: "dashboard",
        name: "Dashboard",
        icon: <BoardSplitIcon />
    },
    {
        id: "schedules",
        name: "Schedules",
        icon: <TimelineIcon />
    },
    {
        id: "therapists",
        name: "Therapists",
        icon: <TherapistsIcon />
    },
    {
        id: "patients",
        name: "Patients",
        icon: <PatientsIcon />
    },
    {
        id: "set-scenario-constraints",
        name: "Scenarios",
        icon: <PatientsIcon />
    },
    {
        id: "biofeedback",
        name: "Biofeedback",
        icon: <HeartPulse />
    },
    {
        id: "settings",
        name: "Settings",
        icon: null
    },
    {
        id: "account",
        name: "Account",
        icon: <AccountIcon />
    },
    {
        id: "preferences",
        name: "Preferences",
        icon: <SettingsIcon />
    },
    {
        id: "about",
        name: "About",
        icon: <InfoIcon />
    }
];


const useStyles = makeStyles({
    tabList: { opacity: '0.85' },
    tabItem: {},
    tabHeader: {
        lineHeight: "32px",
        paddingLeft: "12px",
        paddingTop: "6px"
    },
    customLineColor: {
        paddingTop: '10px',
        fontSize: '13px',
        '::before': {
            ...shorthands.borderColor('rgba(0, 0, 0, 0.06)')
        },
        '::after': {
            ...shorthands.borderColor('rgba(0, 0, 0, 0.06)')
        }
    }
});

export const ControlPanelNavigation = () => {
    const styles = useStyles();
    const [selectedTabId, setSelectedTabId] = React.useState(window.location.pathname);
    const navigate = useNavigate();
    const onTabSelect = (tabId) => {
        setSelectedTabId(tabId);
        navigate("/"+tabId);
    };
    React.useEffect(() => {
        setSelectedTabId(window.location.pathname.substring(1));
     },[]);

    // fetch all therapist's patients to select the one to work with

    const [myPatients, setMyPatients] = React.useState([]);
    const fetchMyPatients = async () => {
        try {
          const response = await fetch(API_PATH.USERS, { headers: {'Cache-Control': 'no-cache'} });
          if (!response.ok) {
            console.error(`HTTP Error: ${response.status} ${response.statusText}`);
            return;
          }

          const data = await response.json();
          console.log('Successfully fetched data about your patients: ', data);
          setMyPatients(data);
        } catch (error) {
          console.error('Network Error:', error.message || error);
        }
    };

    React.useEffect(() => {
        fetchMyPatients();
     },[]);

    const dropdownId = useId("dropdown-default");
    const { selectedPatientId, setSelectedPatientId } = useContext(SelectedPatientContext);
    const onOptionSelect = (_event, data) => setSelectedPatientId(data.optionValue);

    return (
        <>
            <label id={dropdownId}>Selected patient</label>
            <Dropdown
                aria-labelledby={dropdownId}
                placeholder="Select patient"
                onOptionSelect={ onOptionSelect }
                style={{ minWidth: '160px' }}
                selectedOptions={ [selectedPatientId] }
                value={ myPatients.find(patient => patient.id === selectedPatientId)?.username ?? '' }
            >
                {myPatients.map((option) => (
                    <Option key={option.id} text={option.username} value={option.id}>
                        {option.username}
                    </Option>
                ))}
            </Dropdown>
            
            <TabList
                className='tabList'
                appearance="subtle"
                vertical
                selectedValue={selectedTabId}
                onTabSelect={(_, d) => {onTabSelect(d.value);}}
            >
                {tabs.map((tab) => {
                    if (tab.icon == null)
                        return (
                            <Text key={tab.name} className={styles.tabHeader} weight="semibold">{tab.name}</Text>
                        );
                    else
                        return (
                            <Tab key={tab.name} className={styles.tabItem} value={tab.id} icon={<span>{tab.icon}</span>}>{tab.name}</Tab>
                        );
                })}
            </TabList>
        </>
    );
};